<template>
  <div class="loginPage">
    <div class="loginPage__wrapper">
      <div class="loginPage__banner"></div>
      <h1 class="loginPage__title">帳號登入</h1>
      <div class="loginPage__content">
        <input
          class="loginPage__inputField"
          id="serviceteamcode"
          type="text"
          placeholder="車隊編號"
          v-model="team_code"
        />
        <input
          class="loginPage__inputField"
          id="serviceaccount"
          type="text"
          placeholder="客服帳號"
          v-model="account"
        />
        <input
          class="loginPage__inputField"
          id="servicepassword"
          type="password"
          placeholder="客服密碼"
          v-model="password"
        />
        <button class="loginPage__button" @click="onServiceLoginBtnClick">
          登入
        </button>
      </div>
      <div class="loginPage__footer">
        <h1 class="loginPage__title">GLAD Taxi 享受生活</h1>
        <p>©2018-{{ untilYear }} 資通行動科技有限公司{{ VERSION }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import dayjs from 'dayjs'
import { cookies, initLoginCookies } from '@/utils/cookies'
import managerService from '@/API/managerService'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import { appVersion } from '@/constants/general'

export default {
  name: 'PhoneLogin',
  data() {
    return {
      team_code: '',
      account: '',
      password: '',
      untilYear: dayjs().year(),
      VERSION: appVersion,
    }
  },
  mounted() {
    cookies.get('Flag') === 'phone' &&
      this.$router.replace('/phonemain/phoneHail')
  },
  methods: {
    async onServiceLoginBtnClick() {
      try {
        const { result } = await managerService.login({
          account: this.account,
          password: this.password,
          teamCode: this.team_code,
        })
        initLoginCookies(result)
        // 將 teamRoles 存到 Vuex
        if (result.teamRoles) {
          this.$store.commit('managerStore/SET_TEAM_ROLES', result.teamRoles)
        }
        // 傳送token, teamCode, managerName到派車軟體
        // console.log(result.token, result.teamCode, result.managerName);
        window.parent.postMessage(
          `${result.token},${result.teamCode},${result.managerName}`,
          '*',
        )
        API.defaults.headers.common['x-access-token'] = result.token
        // this.$router.replace({ name: "ServicePhoneHail" });
        this.$router.replace({
          name: 'ServicePhoneHail',
          query: { from: 'desktop' },
        })
        BehaviorRecorder.record(
          '點擊',
          '登入畫面',
          '派車軟體登入成功' + this.account,
        )
      } catch (e) {
        this.$notify({
          title: '登入失敗',
          message: '帳號密碼錯誤',
          type: 'error',
        })
        console.error(e)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_loginPage.scss';
</style>



// WEBPACK FOOTER //
// src/pages/ServiceLogin.vue